import type { ApiPaths } from '@reos/api-client';
import { apiClient } from './api.js';
import { unwrap } from './api-error.js';

/**
 * Brand kancelare (krok O5b): logo, dve barvy a paticka, ve kterych se
 * generuji reporty. Zdroj pravdy je `organization` (logo + metadata.brand),
 * UI ho jen cte a zapisuje pres `/v1/tenant-settings/brand` (owner/admin).
 */

export type TenantBrand =
  ApiPaths['/v1/tenant-settings/brand']['get']['responses']['200']['content']['application/json'];

export type TenantBrandPatch =
  ApiPaths['/v1/tenant-settings/brand']['patch']['requestBody']['content']['application/json'];

export async function getTenantBrand(): Promise<TenantBrand> {
  return unwrap(apiClient.GET('/v1/tenant-settings/brand', {}));
}

/** `null` u pole = smazat hodnotu (navrat k vychozimu vzhledu REOS). */
export async function updateTenantBrand(patch: TenantBrandPatch): Promise<TenantBrand> {
  return unwrap(apiClient.PATCH('/v1/tenant-settings/brand', { body: patch }));
}
